var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function CompaniesTab(el) {
  var t = this,
      $el = $(el),
      $selectedTab,
      $selectedGrid,
      $selectedCell;

  t.$tab = $el.find('.companies-tab__filter');
  t.$tabContent = $el.find('.companies-grid');

  t.$tab.on('click', function(e) {
    e.preventDefault();
    t.click(this);
  })

  if (location.hash) {
    $selectedCell = $el.find('[data-company-slug="' + location.hash.replace('#', '') + '"]');
    $selectedGrid = $selectedCell.closest('.companies-grid');
    $selectedTab = $el.find('.companies-tab__filter-link[href="' + $selectedGrid.attr('id') + '"]');
    $selectedTab.click();
    setTimeout(function () {
      $selectedCell.find('.companies-cell__logo').click();
    }, 300);
  }
}

CompaniesTab.prototype.click = function (target) {
  var $target = $(target),
      $targetID = $target.find('a').attr('href'),
      t = this;

  if( !$target.hasClass('js-companies-tab-filter-active') ) {
    t.$tab.removeClass('js-companies-tab-filter-active');
    t.$tabContent.animate({opacity : '0'}, 300).removeClass('js-companies-grid-active');

    $target.addClass('js-companies-tab-filter-active');
    t.$tabContent.filter('#' + $targetID).animate({opacity : '1'}, 300).addClass('js-companies-grid-active');
  } else {
    return;
  }

}

module.exports = CompaniesTab;
